import { Flex, Text } from "@gravity-ui/uikit";
import { useGravityDevice } from "src/hooks/useGravityDevice";

import { TextSection } from "../TextSection";
import { useServicesBlockTranslate } from "./hooks/useServicesBlockTranslate";
import css from "./ServicesBlock.module.scss";

export const ServicesBlock = () => {
  const { isMobile, deviceText } = useGravityDevice();

  const { title, description, servicesData } = useServicesBlockTranslate();

  return (
    <Flex
      id="services"
      direction={"column"}
      width={"100%"}
      maxWidth={"1440px"}
      style={{
        paddingLeft: isMobile ? 30 : 50,
        paddingRight: isMobile ? 30 : 50,
        gap: 60,
      }}
    >
      <TextSection title={title} description={description} />
      <Flex gap={6}>
        <Flex direction={"row"} wrap={"wrap"} gap={6}>
          {servicesData.map((service, index) => {
            return (
              <div
                key={`service.${index}`}
                className={css.ServicesCard}
                style={{
                  flexBasis: isMobile ? "100%" : "45%",
                }}
              >
                <Text
                  variant={deviceText.subheader}
                  style={{ fontWeight: "bold" }}
                >
                  {service.title}
                </Text>
                <Text variant={deviceText.body}>{service.description}</Text>
              </div>
            );
          })}
        </Flex>
      </Flex>
    </Flex>
  );
};
